import { useSubmitWritebackMutation } from '@repo/videa-notes';
import { useQueryClient } from '@tanstack/react-query';

import { makeAPIRequestReactQuery } from '@/react-query/api';

import { endpoints } from '../endpoints';

import type { WritebackPrecheckResponse } from './types';

export const fetchWritebackPrecheck = async (
  clinicalNoteId: string,
  practiceId: string,
  organizationId: string,
): Promise<WritebackPrecheckResponse> => {
  return makeAPIRequestReactQuery<WritebackPrecheckResponse>(
    `/videa-notes/${clinicalNoteId}/writeback-precheck`,
    {},
    'get',
    {
      headers: {
        'Access-Control-Allow-Origin': '*',
        practice: practiceId,
        org: organizationId,
      },
    },
  );
};

export const useSubmitWriteback = () => {
  const queryClient = useQueryClient();

  return useSubmitWritebackMutation<{
    clinicalNoteId: string;
    providerPmsId?: string;
  }>({
    getQueryParams: ({ providerPmsId }) => {
      const queryParams: Record<string, string> = {
        localTimestamp: new Date().toLocaleDateString('en-CA'),
      };

      if (providerPmsId) {
        queryParams.providerPmsId = providerPmsId;
      }

      return queryParams;
    },
    onSuccess: () => {
      queryClient.invalidateQueries([
        endpoints.ambient.voiceNotes.batchNotesByUnifiedAppointmentIds,
      ]);
      queryClient.invalidateQueries([
        endpoints.ambient.voiceNotes.batchNotesByStandalonePatientVisitIds,
      ]);
    },
  });
};
